import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const Uniform = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Uniform"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Uniform" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
       <section class="space-ptb">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-12">
            <div class="section-title mb-4 pr-lg-5 px-4 px-lg-2">
              <h2 class="title"><span class="text-primary">Uniform</span></h2>
<div className="curved-line mx-auto mt-3"></div>
            </div>            
          </div>          
        </div>
        
            <div class="uniform-sections">
                <div class="uniform-column">
                    <h3 class="season-title">Summer Uniform</h3>
                    
                    <div class="class-section">
                        <h4>CLASS NURSERY TO V (SUMMER UNIFORM)</h4>
                        
                        <div class="day-section">
                            <h5>Monday to Thursday</h5>
                            <div class="uniform-details">
                                <div class="gender-group">
                                    <span class="gender-label">Boys</span>
                                    <p>White Half sleeve shirt (with monogram), Grey Half Pant, tie, belt, black shoes & socks.</p>
                                </div>
                                <div class="gender-group">
                                    <span class="gender-label">Girls</span>
                                    <p>White half sleeve shirt grey tunic (with monogram), tie, belt, black shoes & socks.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="class-section">
                        <h4>CLASS NURSERY TO V (SUMMER - P.T. UNIFORM)</h4>
                        
                        <div class="day-section">
                            <h5>Friday</h5>
                            <div class="uniform-details">
                                <div class="gender-group">
                                    <span class="gender-label">Boys</span>
                                    <p>White half sleeve shirt, white half pant, tie, belt, white shoes & socks.</p>
                                </div>
                                <div class="gender-group">
                                    <span class="gender-label">Girls</span>
                                    <p>White half sleeve shirt, white tunic (with monogram), tie, belt, white shoes & socks.</p>
                                </div>
                            </div>
                        </div>

                        <div class="day-section">
                            <h5>Saturday</h5>
                            <div class="uniform-details">
                                <div class="gender-group">
                                    <span class="gender-label">Boys</span>
                                    <p>House T-shirt, white half pant, belt, white shoes & socks.</p>
                                </div>
                                <div class="gender-group">
                                    <span class="gender-label">Girls</span>
                                    <p>House T-shirt, white tunic, belt, white shoes & socks.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="class-section">
                        <h4>CLASS VI TO XII (SUMMER UNIFORM)</h4>
                        
                        <div class="day-section">
                            <h5>Monday to Thursday</h5>
                            <div class="uniform-details">
                                <div class="gender-group">
                                    <span class="gender-label">Boys</span>
                                    <p>White Half sleeve shirt (with monogram), Grey full Pant, tie, belt, black shoes & socks.</p>
                                </div>
                                <div class="gender-group">
                                    <span class="gender-label">Girls</span>
                                    <p>White Half sleeve shirt, Grey tunic (with monogram), tie, belt, black shoes & socks.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="class-section">
                        <h4>CLASS VI TO XII (SUMMER - P.T. UNIFORM)</h4>
                        
                        <div class="day-section">
                            <h5>Friday</h5>
                            <div class="uniform-details">
                                <div class="gender-group">
                                    <span class="gender-label">Boys</span>
                                    <p>White Half sleeve shirt, White full pant, tie, belt, white shoes & socks.</p>
                                </div>
                                <div class="gender-group">
                                    <span class="gender-label">Girls</span>
                                    <p>White Half sleeve shirt, White skirt, tie, belt, white shoes & socks.</p>
                                </div>
                            </div>
                        </div>

                        <div class="day-section">
                            <h5>Saturday</h5>
                            <div class="uniform-details">
                                <div class="gender-group">
                                    <span class="gender-label">Boys</span>
                                    <p>House T-shirt, white full pant, sweater (with monogram), blazer (with monogram), belt white shoes & socks.</p>
                                </div>
                                <div class="gender-group">
                                    <span class="gender-label">Girls</span>
                                    <p>House T-shirt, white skirt, half sweater (with monogram), blazer (with monogram) belt, white shoes & stockings.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="uniform-column">
                    <h3 class="season-title">Winter Uniform</h3>
                    
                    <div class="class-section">
                        <h4>Class Nursery to XII (Winter Uniform)</h4>
                        
                        <div class="day-section">
                            <h5>Monday to Thursday</h5>
                            <div class="uniform-details">
                                <div class="gender-group">
                                    <span class="gender-label">Boys</span>
                                    <p>White full shirt, grey full pant, half sweater (with monogram), blazer (with monogram), tie, belt, black shoes & socks.</p>
                                </div>
                                <div class="gender-group">
                                    <span class="gender-label">Girls</span>
                                    <p>White full sleeve shirts, grey tunic, half sweater (with monogram), blazer (with monogram) tie, belt, black shoes, black stockings. Friday :</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="class-section">
                        <h4>Class Nursery to XII (Winter - P.T. Uniform)</h4>
                        
                        <div class="day-section">
                            <h5>Friday</h5>
                            <div class="uniform-details">
                                <div class="gender-group">
                                    <span class="gender-label">Boys</span>
                                    <p>White full shirt, white full pant, half sweater (with monogram), blazer (with monogram), tie-belt, white shoes & socks.</p>
                                </div>
                                <div class="gender-group">
                                    <span class="gender-label">Girls</span>
                                    <p>White full shirt, white tunic/skirt, half sweater (with monogram), blazer (with monogram), tie-belt, white shoes, & stockings.</p>
                                </div>
                            </div>
                        </div>

                        <div class="day-section">
                            <h5>Saturday</h5>
                            <div class="uniform-details">
                                <div class="gender-group">
                                    <span class="gender-label">Boys</span>
                                    <p>House T-shirt, white full pant, sweater (with monogram), blazer (with monogram), belt white shoes & socks.</p>
                                </div>
                                <div class="gender-group">
                                    <span class="gender-label">Girls</span>
                                    <p>House T-shirt, white skirt, half sweater (with monogram), blazer (with monogram) belt, white shoes & stockings.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
     </div>
    </section>
    </>
  )
}

export default Uniform
